import { selfAxios } from "@oppein/op-utils";
/**
 * 导入审单条件
 */
export async function importReviewCondition(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/designUnifiedRuleController/importReviewCondition",
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/designUnifiedRuleController/importReviewCondition/post.js